export default "__VITE_ASSET__B9b9ACyY__"